import { render, staticRenderFns } from "./BookingRoleStatus.vue?vue&type=template&id=6fb3ae1e&"
import script from "./BookingRoleStatus.vue?vue&type=script&lang=ts&"
export * from "./BookingRoleStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports